/**
 * Common reducer
 *
 * @copyright ©2019 Emden Consulting GmbH
 * @created 2019-11-29
 * @author Johannes Emden <je@emden.io>
 * @author Axel Siebert <a.siebert@emden.io>
 */

// Third-party dependencies
import { Reducer } from 'redux';

// Data models
import { CommonAction, CommonActionType } from '../../models/common/actions';
import { CommonState } from '../../models/common/state';
import { Language } from '../../models/common';

export const initialState: CommonState = {
  drawerOpen: false,
  language: Language.DE,
};

const commonReducer: Reducer<CommonState, CommonAction> = (state = initialState, action) => {
  switch (action.type) {
    case CommonActionType.LANGUAGE_CHANGE: {
      return {
        ...state,
        language: action.language,
      };
    }
    case CommonActionType.TOGGLE_DRAWER: {
      return {
        ...state,
        drawerOpen: action.open,
      };
    }
    case CommonActionType.CLEANUP: {
      return {
        ...initialState,
      };
    }
    default: {
      return state;
    }
  }
};

export default commonReducer;
